import { Injectable } from '@angular/core';

@Injectable()
export class KeyboardService {
  // accessibility: control which keys launch the method
  checkActivationButtonKey(event) {
    if (event?.key === ' ' || event?.key === 'Enter') {
      return true;
    }
    return false;
  }
}
